import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home'),
    meta: {
      title: 'Home'
    }
  },
  {
    path: '/cli',
    component: () => import(/* webpackChunkName: "terminal" */ '../views/cli'),
    redirect: '/cli/tab/0',
    children: [
      {
        path: 'tab/:id',
        component: () => import(/* webpackChunkName: "screen" */ '../views/cli/Screen'),
        meta: {
          title: 'CLI Mode'
        },
      },
    ],
  },
  { 
    path: '*', 
    component: () => import(/* webpackChunkName: "error" */ '../views/404'),
    meta: {
      title: 'Error'
    },
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
